export default "/images/vendor/flag-icon-css/flags/1x1/np.svg?f7885aa646996a2aa6e0da751dd93816";